<script>
    import Vue from 'vue';
    import FileInput from '@/iamteacherpc/components/common/FileInput.vue';
    import {MAX_DOCUMENT_DEFAULT_COUNT, MAX_DOCUMENT_SIZE, POSSIBLE_DOCUMENT_EXT} from '@/iamteacherpc/consts/document.js';
    import {getExtension} from '@/iamteacherpc/utils/file.js';
    import {requestAlert} from '@/iamteacherpc/utils/iframe.js';
    import i18n from '@common/i18n.js';

    export default {
        name: 'DocumentUpload',
        props: {
            multiple: {
                type: Boolean,
                default: false,
            },
            maxCount: {
                type: Number,
                default: MAX_DOCUMENT_DEFAULT_COUNT,
            },
            nowCount: {
                type: Number,
                default: 0,
            },
        },

        render(creatElement) {
            return this.$slots.default || this.$scopedSlots.default(this);
        },

        mounted() {
            const FileInputComponent = Vue.extend(FileInput);

            this.fileInput = new FileInputComponent({
                parent: this,
                propsData: {
                    accept: '.hwp,.hwpx,.doc,.xls,.ppt,.docx,.xlsx,.pptx,.pdf,.cell',
                    multiple: this.multiple,
                }
            });
            this.fileInput.$on('change', this.onChangeFile);

            this.fileInput.$mount();
            this.fileInput.$el.style.display = 'none';
            document.body.appendChild(this.fileInput.$el);
        },

        beforeDestroy() {
            this.fileInput.$destroy();
            document.body.removeChild(this.fileInput.$el);
        },

        methods: {
            openFileDialog() {
                this.fileInput.openFileDialog();
                this.$emit('click');
            },

            onChangeFile(files) {
                for (let i = 0; i < files.length; i += 1) {
                    const file = files[i];

                    if (this.nowCount + i >= this.maxCount) {
                        requestAlert({
                            title: i18n.t('SurveyEditorContent_maxDocumentCount', {max: this.maxCount}),
                            okText: i18n.t('common_confirm'),
                        });
                        return;
                    }

                    const extension = getExtension(file.name);
                    if (!POSSIBLE_DOCUMENT_EXT.find(e => e === extension)) {
                        requestAlert({
                            title: this.$t('DocumentUpload_availableFileExt'),
                            okText: this.$t('common_confirm'),
                        });
                        return;
                    }

                    if (file.size > MAX_DOCUMENT_SIZE) {
                        requestAlert({
                            title: this.$t('DocumentUpload_exceedMaxFileSize'),
                            okText: this.$t('common_confirm'),
                        });
                        return;
                    }

                    this.$emit('requestUpload', file);
                }
            }
        }
    }
</script>

<style scoped>

</style>
